import React from "react";

type IconProps = {
  size?: number;
  color?: string;
};

const FileDisabledIcon: React.FC<IconProps> = ({
  size = 92,
  color = "#D2E0E8",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 92 92"
      fill="none"
    >
      <path
        d="M53.7251 24.0167V34.0583L86.025 66.3582C89.0329 60.6201 90.745 54.0953 90.745 47.1541C90.745 37.3438 87.3207 28.3202 81.6289 21.1939C79.6391 18.8339 77.4641 16.6127 75.1041 14.6691C67.9315 8.93106 58.9079 5.50672 49.0976 5.50672C42.1564 5.50672 35.6317 7.21889 29.8936 10.2268L43.6835 24.0167H53.7251Z"
        fill={color}
      />
      <path
        d="M6.57103 0L0 6.52476L15.7335 22.2582C10.5507 29.1994 7.45026 37.8066 7.45026 47.1541C7.45026 70.1527 26.0528 88.8015 49.0976 88.8015C58.4452 88.8015 67.0523 85.7011 73.9935 80.5183L85.0995 91.6243L91.6243 85.0995L6.57103 0Z"
        fill={color}
      />
    </svg>
  );
};

export default FileDisabledIcon;